import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import config from 'utils/config';
import useFetchTeamManagers from 'actions/team/useFetchTeamManagers';
import BulletList from 'components/BulletList';
import TeamManagersDropdown from './TeamManagersDropdown';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function EditingPermissionsSummary(_ref) {
  var owningTeamsIds = _ref.owningTeamsIds,
    hasMemberContributions = _ref.hasMemberContributions,
    isDistributed = _ref.isDistributed;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFetchTeamManagers = useFetchTeamManagers({
      teamIds: owningTeamsIds
    }),
    managers = _useFetchTeamManagers.items;
  var memberContributions = config.memberContributions,
    enableTeamPlaylists = config.enableTeamPlaylists;
  var managerCount = managers === null || managers === void 0 ? void 0 : managers.length;
  var hasOwningTeam = !!owningTeamsIds.length && enableTeamPlaylists;
  var generalSummary = isDistributed ? t('playlist_access_who_can_edit_this_general_distributed_info') : t('playlist_access_who_can_edit_this_general_info');
  var distributedPlaylistsEditingPermissions = (memberContributions || enableTeamPlaylists) && isDistributed ? t('playlist_access_who_can_edit_this_distributed_info') : null;
  var owningTeamEditingPermissions = null;
  if (hasOwningTeam && managerCount) {
    owningTeamEditingPermissions = /*#__PURE__*/_jsxs(Trans, {
      t: t,
      i18nKey: "playlist_access_who_can_edit_this_teams_info",
      count: managerCount,
      children: ["The", ' ', /*#__PURE__*/_jsx(TeamManagersDropdown, {
        managers: managers,
        children: "count managers"
      }), "of the owning team can edit this playlist's details and\n\t\t\tcontent."]
    });
  } else if (hasOwningTeam && !managerCount) {
    owningTeamEditingPermissions = t('playlist_access_who_can_edit_this_teams_no_manager_info');
  }
  var memberContributionsEditingPermissions = hasMemberContributions && memberContributions ? t('playlist_access_who_can_edit_this_members_info') : null;
  var permissions = [generalSummary, distributedPlaylistsEditingPermissions, owningTeamEditingPermissions, memberContributionsEditingPermissions].filter(function (el) {
    return el !== null;
  });
  return /*#__PURE__*/_jsx(BulletList, {
    children: permissions.map(function (item, i) {
      return /*#__PURE__*/_jsx(React.Fragment, {
        children: item
      }, i);
    })
  });
}
export default EditingPermissionsSummary;